import { render, staticRenderFns } from "./coa.vue?vue&type=template&id=faeaa6c0"
import script from "./coa.vue?vue&type=script&lang=js"
export * from "./coa.vue?vue&type=script&lang=js"
import style0 from "./coa.vue?vue&type=style&index=0&id=faeaa6c0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports